import * as PIXI from 'pixi.js'
import SpineEditor from './spineEditor'
import { getStageRef, McSpine } from '../../utils'

export default class SpineDummyCreator extends React.Component {
  state = {}
  componentDidMount() {
    const stage = getStageRef()
    if (stage.dummySpineContainer) {
      this.setState({ currentSpines: stage.dummySpineContainer.children })
    }
  }

  createSpine = (key) => {
    const stage = getStageRef()

    if (!stage.dummySpineContainer) {
      stage.dummySpineContainer = new PIXI.Container()
      stage.addChild(stage.dummySpineContainer)
    }

    const dummySpine = new McSpine(PIXI.Loader.shared.resources[key].spineData)
    stage.dummySpineContainer.addChild(dummySpine)
    dummySpine.position.set(window.innerWidth / 2, window.innerHeight / 2)
    dummySpine.spineName = key
    dummySpine.uniqueId = `_${Math.random().toString(36).substr(2, 9)}`

    this.updateChildren()
  }

  moveSpine = (spine, direction) => {
    const stage = getStageRef()
    const dummySpines = stage.dummySpineContainer
    const currentIndex = dummySpines.children.indexOf(spine)
    dummySpines.removeChild(spine)
    dummySpines.addChildAt(spine, currentIndex + direction)

    this.updateChildren()
  }

  removeSpine = (spine) => {
    const stage = getStageRef()
    const dummySpines = stage.dummySpineContainer
    dummySpines.removeChild(spine)
    spine.destroy()
    this.updateChildren()
  }

  selectSpine = (spine) => {
    this.setState({ selectedSpine: spine })
  }

  updateChildren = () => {
    const stage = getStageRef()
    this.setState({ currentSpines: stage.dummySpineContainer.children })
  }

  render() {
    const { entries } = this.props
    const { currentSpines = [], selectedSpine } = this.state

    return (
      <div id="spineDummyCreator">
        <div className="spineList">
          <div>Available spines</div>
          { entries.map(entry => (
            <div className="spine" key={`${entry[0]}-dummyChoice`}>
              <p>{entry[0]}</p>
              <input type="button" value="Create spine" onClick={() => this.createSpine(entry[0])} />
            </div>
          ))}
          <div className="currentSpines">Current dummy spines</div>
          { currentSpines.map((spine, i) => {
            const canMoveToBack = i > 0
            const canMoveToFront = i < currentSpines.length - 1
            return (
              <div className="dummySpine" key={`dummy-${spine.uniqueId}`}>
                <div className="spineName">{spine.spineName}!</div>
                <input type="button" value="Edit" onClick={() => { this.selectSpine(spine) }} />
                { canMoveToBack ? <input type="button" value="Move backward" onClick={() => { this.moveSpine(spine, -1) }} /> : <div />}
                { canMoveToFront ? <input type="button" value="Bring forward" onClick={() => [ this.moveSpine(spine, 1) ]} /> : <div /> }
                <input type="button" value="Delete" onClick={() => { this.removeSpine(spine) }} />
              </div>
            )
          })}
        </div>
        { selectedSpine && <SpineEditor key={`editor-${selectedSpine.uniqueId}`} spine={selectedSpine} /> }
      </div>
    )
  }
}